import { progress } from '@inertiajs/vue3'
import axios from 'axios'
import _ from 'lodash'

window._ = _
window.axios = axios

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

// Inertia configures progress after the initial mount; never block Axios on that.
function startProgress() {
  try {
    progress.start()
  } catch {
    // Progress not ready yet.
  }
}

function finishProgress() {
  try {
    progress.finish()
  } catch {
    // Progress not ready yet.
  }
}

window.axios.interceptors.request.use(
  function (config) {
    startProgress()

    config.headers['Accept-Language'] = document.documentElement.lang ?? 'de'

    return config
  },
  function (error) {
    finishProgress()
    console.error(error)
    return Promise.reject(error)
  },
)

window.axios.interceptors.response.use(
  function (response) {
    finishProgress()
    return response
  },
  function (error) {
    finishProgress()
    console.error(error)
    return Promise.reject(error)
  },
)

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
